export default __webpack_public_path__ + "static/media/min_not_met.16b687b9.png";